import type { RootState } from "@/data/store";
import { recordingStartCutoffDatePassed } from "@/features/socratic/socratic-slice/socratic-slice";

import { createDateListener } from "../timeline-listeners/create-date-listener";

/**
 * Listener for the recording start cutoff date in Socratic session timeline.
 *
 * Monitors when the cutoff time passes and marks the cutoff date as passed.
 */
export const recordingStartCutoffDateListener = createDateListener(
  (state: RootState) => state.socratic.recordingStartCutoffDate,
  (listenerApi) => {
    listenerApi.dispatch(recordingStartCutoffDatePassed());
  }
);
